"use client";

import { COMPANY_EMAILS } from "@repo/common";
import { Minus, Plus } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

import { expertFaqs } from "@/app/(marketing)/_components/faq-data";
import { Container } from "@/app/(marketing)/_components/ui/container";
import { cn } from "@/lib/utils";

export default function ExpertsFAQ() {
  const [openId, setOpenId] = useState<string>(expertFaqs[0]?.id ?? "");

  return (
    <section className="bg-marketing-cream py-24 md:py-28">
      <Container>
        <div className="mx-auto flex max-w-[775px] flex-col gap-16">
          <div className="flex flex-col items-center gap-5 text-center">
            <h2 className="text-marketing-text text-4xl leading-tight font-medium tracking-tight md:text-[44px]">
              FAQs
            </h2>
            <p className="text-marketing-text-muted text-base leading-relaxed md:text-lg">
              We love that you are curious. For more questions please write to
              us at{" "}
              <Link
                href={"mailto:" + COMPANY_EMAILS.support}
                className="text-marketing-blue transition-colors hover:underline"
              >
                {COMPANY_EMAILS.support}
              </Link>
              .
            </p>
          </div>

          <div className="border-marketing-border-light flex flex-col divide-y">
            {expertFaqs.map((faq) => {
              const isOpen = faq.id === openId;
              return (
                <div key={faq.id}>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => {
                      setOpenId(isOpen ? "" : faq.id);
                    }}
                    className="flex w-full items-start justify-between gap-8 py-6 text-left"
                  >
                    <span className="text-marketing-text min-w-0 flex-1 text-lg leading-snug font-medium md:text-xl">
                      {faq.question}
                    </span>
                    <span className="text-marketing-text shrink-0">
                      {isOpen ? (
                        <Minus className="h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Plus className="h-6 w-6" aria-hidden="true" />
                      )}
                    </span>
                  </button>
                  <div
                    className={cn(
                      "grid transition-[grid-template-rows] duration-200 ease-out",
                      isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
                    )}
                  >
                    <div className="min-h-0 overflow-hidden">
                      <p className="text-marketing-text-muted pb-6 text-base leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
}
